import StatisticListGroup from './StatisticListGroup';

export default StatisticListGroup;